'use-client'

import { useState } from 'react'
import { Loader2Icon } from 'lucide-react'
import { toast } from 'sonner'

import { Label } from '@/components/ui/label'
import { Switch } from '@/components/ui/switch'

export const DashboardToggle = ({
  label,
  setValue,
  value,
}: {
  label: string
  setValue: (value: boolean) => void
  value: boolean
}) => {
  const [isPatching, setIsPatching] = useState(false)

  const handleSetValue = async (show: boolean) => {
    setIsPatching(true)
    try {
      await setValue(show)
    } catch (error) {
      toast.error(error instanceof Error ? error.message : 'An unknown error occurred')
    } finally {
      setIsPatching(false)
    }
    setIsPatching(false)
  }
  return (
    <div className="flex flex-row items-center gap-2">
      <div className="flex items-center space-x-2">
        {isPatching ? (
          <Loader2Icon className="size-4 animate-spin" />
        ) : (
          <Switch
            id="winTracker"
            className="cursor-pointer"
            checked={value}
            onCheckedChange={handleSetValue}
          />
        )}
        <h3 className="font-family-body text-lg font-medium text-foreground">{label}</h3>
        <Label
          htmlFor="winTracker"
          className="sr-only my-0 font-body text-base text-card-foreground"
        >
          Show on dashboard
        </Label>
      </div>
    </div>
  )
}
